import React from "react";
import { useAuth } from "../../context/AuthContext";
import SignupWallPage from "./SignupWallPage";

/**
 * AnonymousGate — iter189
 *
 * Route wrapper that renders SignupWallPage for anonymous visitors.
 * Wrap gated routes in App.js like:
 *   <Route path="/browse" element={<AnonymousGate><Browse /></AnonymousGate>} />
 *
 * IMPORTANT — grandfathering rule: any visitor with an existing account
 * (including "free forever" members who joined before iter189) bypasses
 * this gate the instant AuthContext resolves `user`. No new paid-tier
 * flag is added — every signed-in user gets the full app, forever.
 *
 * While auth is loading we render nothing to avoid a flash-of-wall for
 * signed-in users on first load.
 */
export default function AnonymousGate({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#fafafa] flex items-center justify-center" data-testid="anon-gate-loading">
        <div className="w-6 h-6 border-2 border-[#ff4500] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <SignupWallPage />;
  return children;
}
